export const EMAILS_ROOT = '/emails'

export const EMAILS_API_SEND = '/email/send-to-organizations'
